// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__EVW9C","dragIcon":"Choice_dragIcon__1GLXC","left":"Choice_left__1E-jc","input":"Choice_input__1rM3g"};